import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { GridEventListener, GridEvents, GridRowParams } from "@mui/x-data-grid-pro";

import { INVENTORY_SHEET_PAGE_PATH } from "../../../middleware/routes";
import { getCollectionPointDetailThunk } from "../../../reducers/collectionPointReducer";
import { getWeightHistoryThunk } from "../../../reducers/weightHistoryReducer";
import { IInventorySheetContainer } from "../../../types/inventorySheet";
import { buildWeightHistoryUrl } from "../../../utils/url";

interface InventorySheetTableHandlers {
  handleAdditionalRowClick: GridEventListener<GridEvents.rowClick>;
}

export const useGetInventorySheetTableHandlers = (): InventorySheetTableHandlers => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleAdditionalRowClick: GridEventListener<GridEvents.rowClick> = (
    params: GridRowParams<IInventorySheetContainer>
  ) => {
    const containerId = String(params.row.containerId);
    const locationId = String(params.row.locationId);

    dispatch(getCollectionPointDetailThunk(Number(locationId)));
    dispatch(getWeightHistoryThunk(Number(containerId)));

    history.push(buildWeightHistoryUrl(locationId, containerId, { prevPage: INVENTORY_SHEET_PAGE_PATH }));
  };

  const inventorySheetTableHandlers: InventorySheetTableHandlers = {
    handleAdditionalRowClick,
  };

  return inventorySheetTableHandlers;
};
